"use client"

import { Link } from "react-router-dom"
import "./HomePage.css"
import { Smartphone, Shield, Heart, Star, Users, Sparkles, Camera, Search, Zap, Instagram } from "lucide-react"

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      {/* Header */}
      <header className="container mx-auto px-4 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 no-underline">
          <img src="/assets/icon.png" alt="whatsin? logo" className="rounded-xl w-12 h-12 shadow-lg" />
          <span className="text-2xl font-bold">
            <span style={{ color: "#ff9f43" }}>whatsin</span>
            <span style={{ color: "#ff9f43" }}>?</span>
          </span>
        </Link>
        <nav className="flex items-center gap-2 md:gap-6">
          <a
            href="#features"
            className="text-gray-600 hover:text-gray-900 font-medium transition-colors px-3 py-2 rounded-lg hover:bg-orange-50 text-sm md:text-base"
            onClick={(e) => {
              e.preventDefault()
              document.getElementById("features")?.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Özellikler
          </a>
          <a
            href="#how-it-works"
            className="text-gray-600 hover:text-gray-900 font-medium transition-colors px-3 py-2 rounded-lg hover:bg-orange-50 text-sm md:text-base"
            onClick={(e) => {
              e.preventDefault()
              document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Nasıl Çalışır
          </a>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="container mx-auto px-4 py-12 md:py-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8 order-1 lg:order-1">
            <div className="space-y-6">
              <div
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium shadow-sm"
                style={{ backgroundColor: "#fff7ed", color: "#ff9f43" }}
              >
                <Sparkles className="w-4 h-4" />✨ 30.000+ Ürün Veritabanı
              </div>
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight text-gray-800">
                <span style={{ color: "#ff9f43" }}>Sana uygun</span> ürünleri{" "}
                <span className="bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
                  saniyeler
                </span>{" "}
                içinde bul! 💄✨
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                Ürünü ara, tarayarak bul ya da içerik listesini fotoğrafla! Hem güvenli hem de cilt tipine uygun
                seçimleri saniyeler içinde keşfet! 🌟
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://apps.apple.com/tr/app/whatsin/id6744443804"
                className="inline-flex items-center justify-center gap-3 text-white px-8 py-4 text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all no-underline"
                style={{ backgroundColor: "#ff9f43" }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "#e8873a")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#ff9f43")}
              >
                <Smartphone className="w-6 h-6" />
                App Store'dan İndir
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.ebru.whatsinapp"
                className="inline-flex items-center justify-center gap-3 border-2 text-gray-600 px-8 py-4 text-lg font-semibold rounded-xl bg-white transition-all opacity-60 cursor-not-allowed no-underline"
                style={{ backgroundColor: "white", borderColor: "black" }}
              >
                🤖 Google Play Store'dan İndir
              </a>
            </div>

            <div className="flex items-center gap-8 pt-6">
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: "#ff9f43" }}>
                  30K+
                </div>
                <div className="text-sm text-gray-600">Ürün</div>
              </div>
              <div className="text-center">
                <div className="flex items-center gap-1 text-3xl font-bold text-gray-700 justify-center">
                  <Star className="w-8 h-8 fill-current" style={{ color: "#ff9f43" }} />
                  4.8
                </div>
                <div className="text-sm text-gray-600">App/Play Store</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-pink-500">10000+</div>
                <div className="text-sm text-gray-600">Kullanıcı</div>
              </div>
            </div>
          </div>

          <div className="relative order-2 lg:order-2 flex justify-center mt-8 lg:mt-0">
            <div className="relative">
              <div className="relative mx-auto w-72 h-[580px] md:w-80 md:h-[650px] bg-gradient-to-br from-gray-900 to-black rounded-[3rem] p-2 shadow-2xl">
                {/* Phone Screen */}
                <div className="w-full h-full rounded-[2.5rem] overflow-hidden relative bg-white">
                  {/* Status Bar */}
                  <div className="bg-gray-50 px-6 py-4 flex justify-between items-center text-xs font-medium text-gray-800">
                    <span>9:41</span>
                    <div className="w-20 h-4 bg-black rounded-full"></div>
                    <div className="flex items-center gap-1">
                      <div className="w-4 h-2 bg-green-500 rounded-sm"></div>
                      <span className="text-xs">100%</span>
                    </div>
                  </div>

                  {/* App Header */}
                  <div className="px-6 py-5" style={{ backgroundColor: "#ff9f43" }}>
                    <div className="flex items-center justify-center">
                      <span className="text-white font-bold text-lg">whatsin?</span>
                    </div>
                  </div>

                  {/* Search Bar */}
                  <div className="px-6 py-5 bg-gray-50">
                    <div className="bg-white rounded-xl px-4 py-4 shadow-sm border border-gray-200">
                      <div className="flex items-center justify-center gap-3">
                        <Search className="w-5 h-5 text-gray-400" />
                        <div className="text-gray-400 text-sm">Ürün ara veya barkod tara...</div>
                      </div>
                    </div>
                  </div>

                  {/* App Content */}
                  <div
                    className="flex-1 flex flex-col items-center justify-center p-6 bg-white"
                    style={{ minHeight: "240px" }}
                  >
                    <div className="text-center space-y-6">
                      <div
                        className="w-24 h-24 mx-auto rounded-2xl flex items-center justify-center animate-pulse shadow-lg"
                        style={{ backgroundColor: "#fff7ed" }}
                      >
                        <Search className="w-12 h-12" style={{ color: "#ff9f43" }} />
                      </div>
                      <div className="space-y-4">
                        <div className="text-xl font-semibold text-gray-800">Ürün Analiz Ediliyor...</div>
                        <div className="w-48 h-2 bg-gray-200 rounded-full overflow-hidden relative mx-auto">
                          <div
                            className="absolute top-0 left-0 h-full rounded-full animate-search-progress"
                            style={{ backgroundColor: "#ff9f43" }}
                          ></div>
                        </div>
                        <div className="text-sm text-gray-500">Güvenirlik ve uygunluk kontrolü</div>
                      </div>
                    </div>
                  </div>

                  {/* Tab Bar */}
                  <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-4 py-4 rounded-b-[2.5rem]">
                    <div className="flex justify-around items-center">
                      <div className="flex flex-col items-center gap-1">
                        <div
                          className="w-8 h-8 rounded-xl flex items-center justify-center"
                          style={{ backgroundColor: "#ff9f43" }}
                        >
                          <Search className="w-4 h-4 text-white" />
                        </div>
                        <div className="text-xs font-medium" style={{ color: "#ff9f43" }}>
                          Ara
                        </div>
                      </div>
                      <div className="flex flex-col items-center gap-1">
                        <div className="w-8 h-8 bg-gray-200 rounded-xl flex items-center justify-center">
                          <Heart className="w-4 h-4 text-gray-500" />
                        </div>
                        <div className="text-xs text-gray-400">Favoriler</div>
                      </div>
                      <div className="flex flex-col items-center gap-1">
                        <div className="w-8 h-8 bg-gray-200 rounded-xl flex items-center justify-center">
                          <Users className="w-4 h-4 text-gray-500" />
                        </div>
                        <div className="text-xs text-gray-400">Profil</div>
                      </div>
                      <div className="flex flex-col items-center gap-1">
                        <div className="w-8 h-8 bg-gray-200 rounded-xl flex items-center justify-center">
                          <Sparkles className="w-4 h-4 text-gray-500" />
                        </div>
                        <div className="text-xs text-gray-400">Keşfet</div>
                      </div>
                    </div>

                    {/* Home Indicator */}
                    <div className="mt-3 flex justify-center">
                      <div className="w-32 h-1 bg-gray-300 rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center animate-bounce shadow-lg">
                <Heart className="w-8 h-8 text-pink-500" />
              </div>
              <div
                className="absolute -bottom-4 -left-4 w-16 h-16 rounded-full flex items-center justify-center animate-pulse shadow-lg"
                style={{ backgroundColor: "#fff7ed" }}
              >
                <Shield className="w-8 h-8" style={{ color: "#ff9f43" }} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-20 bg-gradient-to-br from-white via-orange-50 to-white">
        <div className="container mx-auto px-4">
          <div className="text-center space-y-6 mb-16">
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium shadow-sm"
              style={{ backgroundColor: "#fff7ed", color: "#ff9f43" }}
            >
              <Sparkles className="w-4 h-4" />🔥 Harika Özellikler
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800">
              Neden <span style={{ color: "#ff9f43" }}>whatsin?</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Sağlıklı yaşam için ihtiyacın olan her şey, avucunun içinde! 🌈
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border-0 hover:scale-105 group">
              <div className="text-center space-y-4">
                <div
                  className="w-16 h-16 mx-auto rounded-2xl flex items-center justify-center group-hover:rotate-12 transition-transform shadow-md"
                  style={{ backgroundColor: "#fff7ed" }}
                >
                  <Camera className="w-8 h-8" style={{ color: "#ff9f43" }} />
                </div>
                <h3 className="text-xl font-bold text-gray-800">Ara & Tara</h3>
                <p className="text-gray-600">Ürünü ismiyle ara, barkod tara ya da içerik listesini fotoğrafla! 📸</p>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border-0 hover:scale-105 group">
              <div className="text-center space-y-4">
                <div className="w-16 h-16 mx-auto bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl flex items-center justify-center group-hover:rotate-12 transition-transform shadow-md">
                  <Shield className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-bold text-gray-800">Güvenirlik Puanı</h3>
                <p className="text-gray-600">Her ürün için detaylı güvenirlik analizi ve puanlama! 🛡️</p>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border-0 hover:scale-105 group">
              <div className="text-center space-y-4">
                <div className="w-16 h-16 mx-auto bg-gradient-to-br from-pink-400 to-pink-600 rounded-2xl flex items-center justify-center group-hover:rotate-12 transition-transform shadow-md">
                  <Heart className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-800">Cilt Tipi Analizi</h3>
                <p className="text-gray-600">Cilt tipine özel, sana en uygun ürün önerileri! 💖</p>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border-0 hover:scale-105 group">
              <div className="text-center space-y-4">
                <div className="w-16 h-16 mx-auto bg-gradient-to-br from-purple-400 to-purple-600 rounded-2xl flex items-center justify-center group-hover:rotate-12 transition-transform shadow-md">
                  <Search className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-800">30K+ Ürün</h3>
                <p className="text-gray-600">Sürekli güncellenen dev ürün veritabanı! 🗃️</p>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border-0 hover:scale-105 group">
              <div className="text-center space-y-4">
                <div className="w-16 h-16 mx-auto bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-2xl flex items-center justify-center group-hover:rotate-12 transition-transform shadow-md">
                  <Zap className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-800">Hızlı Analiz</h3>
                <p className="text-gray-600">Saniyeler içinde sonuç, hiç beklemeden! ⚡</p>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border-0 hover:scale-105 group">
              <div className="text-center space-y-4">
                <div className="w-16 h-16 mx-auto bg-gradient-to-br from-green-400 to-green-600 rounded-2xl flex items-center justify-center group-hover:rotate-12 transition-transform shadow-md">
                  <Sparkles className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-800">Ücretsiz</h3>
                <p className="text-gray-600">Tüm özellikler tamamen ücretsiz! 🎉</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center space-y-6 mb-16">
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium shadow-sm"
              style={{ backgroundColor: "#fff7ed", color: "#ff9f43" }}
            >
              <Zap className="w-4 h-4" />🚀 Süper Kolay
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800">
              3 Adımda <span style={{ color: "#ff9f43" }}>Güvenli Seçim!</span>
            </h2>
          </div>

          <div className="grid sm:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center space-y-6 group">
              <div className="relative">
                <div
                  className="w-24 h-24 mx-auto rounded-full flex items-center justify-center text-white text-2xl font-bold group-hover:scale-110 transition-transform shadow-lg"
                  style={{ background: "linear-gradient(135deg, #ff9f43 0%, #f7931e 100%)" }}
                >
                  1
                </div>
              </div>
              <div className="space-y-3">
                <h3 className="text-2xl font-bold text-gray-800">Ara & Tara 🔍</h3>
                <p className="text-gray-600">
                  Ürünü ismiyle ara, barkod tara ya da içerik listesini kamera ile fotoğrafla
                </p>
              </div>
            </div>

            <div className="text-center space-y-6 group">
              <div className="relative">
                <div
                  className="w-24 h-24 mx-auto rounded-full flex items-center justify-center text-white text-2xl font-bold group-hover:scale-110 transition-transform shadow-lg"
                  style={{ background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)" }}
                >
                  2
                </div>
              </div>
              <div className="space-y-3">
                <h3 className="text-2xl font-bold text-gray-800">Analiz Et ⚡</h3>
                <p className="text-gray-600">Saniyeler içinde hem güvenirlik hem de cilt tipi uygunluk analizi al</p>
              </div>
            </div>

            <div className="text-center space-y-6 group">
              <div className="relative">
                <div
                  className="w-24 h-24 mx-auto rounded-full flex items-center justify-center text-white text-2xl font-bold group-hover:scale-110 transition-transform shadow-lg"
                  style={{ background: "linear-gradient(135deg, #4ade80 0%, #22c55e 100%)" }}
                >
                  3
                </div>
              </div>
              <div className="space-y-3">
                <h3 className="text-2xl font-bold text-gray-800">Güvenle Seç ✨</h3>
                <p className="text-gray-600">Sana en uygun ve güvenli ürün seçimleri yap</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        className="py-20"
        style={{ background: "linear-gradient(135deg, #ff9f43 0%, #f7931e 50%, #e8873a 100%)" }}
      >
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto space-y-8 text-white">
            <h2 className="text-4xl md:text-5xl font-bold leading-tight">Sana uygun ürünleri keşfet! 🌟</h2>
            <p className="text-xl opacity-90">
              30.000+ ürün arasından hem güvenli hem de cilt tipine uygun olanları bul. Bilinçli seçimler yapmak hiç bu
              kadar kolay olmamıştı! 💖
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://apps.apple.com/tr/app/whatsin/id6744443804"
                className="inline-flex items-center justify-center gap-3 bg-white hover:bg-gray-100 px-8 py-4 text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all no-underline"
                style={{ color: "#ff9f43" }}
              >
                <Smartphone className="w-5 h-5" />
                App Store'dan İndir
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.ebru.whatsinapp"
                className="inline-flex items-center justify-center gap-3 border-2 text-gray-600 px-8 py-4 text-lg font-semibold rounded-xl bg-white transition-all opacity-60 cursor-not-allowed no-underline"
                style={{ backgroundColor: "white", borderColor: "black" }}
              >
                🤖 Google Play Store'dan İndir
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-6 pt-6 text-sm opacity-80">
              <div className="flex items-center gap-2">
                <Star className="w-5 h-5 fill-current" />
                <span>4.8/5 App/Play Store</span>
              </div>
              <div className="flex items-center gap-2">
                <Users className="w-5 h-5" />
                <span>10000+ Mutlu Kullanıcı</span>
              </div>
              <div className="flex items-center gap-2">
                <Shield className="w-5 h-5" />
                <span>Güvenilir Analiz</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 gap-8 items-center">
            <div className="space-y-4 text-center sm:text-left">
              <div className="flex items-center gap-3 justify-center sm:justify-start">
                <img src="/assets/icon.png" alt="whatsin? logo" className="rounded-lg w-10 h-10" />
                <span className="text-2xl font-bold text-white">
                  whatsin?
                </span>
              </div>
              <p className="text-gray-400">Güzellik dünyasında akıllı rehberin! 💄✨</p>
            </div>
            <div className="flex flex-wrap gap-4 justify-center sm:justify-end items-center">
              <a
                href="https://www.instagram.com/whatsin_app/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors no-underline flex items-center gap-2"
              >
                <Instagram className="w-5 h-5" />
                <span className="hidden sm:inline">Instagram</span>
              </a>
              <Link to="/support" className="text-gray-400 hover:text-white transition-colors no-underline">
                İletişim
              </Link>
              <Link to="/legal" className="text-gray-400 hover:text-white transition-colors no-underline">
                Kullanım Koşulları
              </Link>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>&copy; 2026 whatsin Tüm hakları saklıdır. Made with 💖 for healthy living.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default HomePage
